export interface APIErrorResponseInterface {
  code: number;
  title: string;
  description: string;
  details?: any;
}

// Backwards compatibly:
// We've some existing code that references this type
export type ErrorResponse = APIErrorResponseInterface;

export type CustomDomainSsoErrorResponse = {
  code?: string;
  error: string;
};

export type SsoValidationErrorResponse = {
  error: string;
  type?: string;
};

export type RegistrationsErrorResponse = {
  code: string;
  error: string;
};

export type RecordingsErrorResponse = { error?: string[] };

export function isRecordingsError(
  obj: unknown
): obj is RecordingsErrorResponse {
  return Boolean((obj as RecordingsErrorResponse)?.error);
}

export class APIErrorResponse
  extends Error
  implements APIErrorResponseInterface {
  code: number;
  title: string;
  description: string;
  details?: any;

  constructor(code: number, title: string, description: string, details: any) {
    super(description);
    this.code = code;
    this.title = title;
    this.description = description;
    this.details = details;
  }

  static fromJSON(error: any) {
    return new APIErrorResponse(
      // For some reason the backend returns error.code as a string
      // While JS is able to handle numeric strings as numbers
      // But we want make sure it's cast a number for correctness
      error?.code ? parseInt(error.code) : 400,
      error?.title || "",
      error?.description || "",
      error?.details || {}
    );
  }
}

export class RecordingsError extends Error {
  constructor(message) {
    super(message);
    this.name = "RecordingsError";
  }
}

export class OEmbedError extends Error {
  constructor(message) {
    super(message);
    this.name = "OEmbedError";
  }
}
